import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom';

export default function MoviesInfoPage() {
  const [itemInfo,setItemInfo] = useState({});
  const [loading,setLoading] = useState(false);
  const params = useParams();
  const nav = useNavigate();

  useEffect(() => {
    doApi();
  },[params])

  const doApi = async() => {
    try {
      const id = params["id"];
      const url = `http://www.omdbapi.com/?i=${id}&apikey=25832c59`;
      setLoading(true);
      const {data} = await axios.get(url);
      setItemInfo(data);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="container my-5">
      {loading ? 
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
          <h2 className="text-muted">Loading...</h2>
        </div> : 
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10">
            <div className="card shadow-sm">
              <div className="card-body text-center">
                <h1 className="card-title mb-4"> Info about {itemInfo.Title} movie </h1>
                <img src={itemInfo.Poster} alt={itemInfo.Title} className="img-fluid rounded mb-4" style={{ maxHeight: "300px" }}/>
                <div className="mb-3 text-muted">
                  Genre: {itemInfo.Genre} | Release date: {itemInfo.Released}
                </div>
                <div className="row text-start mb-4">
                  <div className="col-md-6 mb-2">
                    <strong>Rating:</strong> {itemInfo.imdbRating}
                  </div>
                  <div className="col-md-6 mb-2">
                    <strong>Runtime:</strong> {itemInfo.Runtime}
                  </div>
                  <div className="col-12 mb-2">
                    <strong>Writer:</strong> {itemInfo.Writer}
                  </div>
                  <div className="col-12">
                    <strong>Actors:</strong> {itemInfo.Actors}
                  </div>
                </div>
                <button className="btn btn-dark px-4" onClick={() => { nav(-1) }}> Back to list </button>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  )
}